import { Button, styled } from "@mui/material";
import type { ButtonProps } from "@mui/material/Button";
import { applyGradientText, applyGradientUnderline } from "../../constants/gradient";

interface NavButtonProps extends ButtonProps {
  active?: boolean;
  to?: string;
}

export const NavButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "active",
})<NavButtonProps>(({ theme, active }) => {
  // Keep using sitewide gradient helpers
  const gradientTextStyle = applyGradientText(theme);

  return {
    fontWeight: active ? 600 : 500,
    fontSize: 16,
    textTransform: "none",
    backgroundColor: "transparent",
    padding: "6px 10px",
    borderRadius: 0,
    minWidth: "auto",
    cursor: "pointer",
    userSelect: "none",
    position: "relative",
    color: theme.palette.text.primary,
    transition: "color 0.3s ease",
    // Standardized underline treatment (hover/focus/active)
    ...applyGradientUnderline(theme, { height: 3, inset: "10%" }),

    // Apply gradient text on active
    ...(active && {
      ...gradientTextStyle,
      "&::after": {
        transform: "scaleX(1)",
      },
    }),

    // On hover, gradient text and underline
    "&:hover": {
      ...gradientTextStyle,
      backgroundColor: "transparent",
    },

    // Rely on underline focus-visible behavior from applyGradientUnderline
  };
});
